import React from 'react';
import { Error } from '../../../ui/Error/Error';

const CaseCreationErrorAlert = (props) => {
  const { labels } = props;

  const config = {
    buttons: [],
    codeLabel: `${labels.errorMessageCodeLabel}`,
    handleCallback: () => {},
    imgAlt: 'labels.errorMessage.imgAlt',
    imgSrc:
      'https://mss-p-007-delivery.sitecorecontenthub.cloud/api/public/content/9bfd65ed69994fa49be3ff1339ea9674?v=cc7c6ec3',
    imgWidth: 116,
    text: 'labels.errorMessage.text',
    title: 'labels.errorMessage.title',
  };

  const errorLabels = {
    'labels.errorMessage.codeLabel': `${labels.errorMessageCodeLabel}`,
    'labels.errorMessage.imgAlt': `${labels.errorMessageImgAlt}`,
    'labels.errorMessage.text': `${labels.errorMessageBody}`,
    'labels.errorMessage.title': `${labels.errorMessageTitle}`,
  };

  return <Error config={config} data={{}} labels={errorLabels} />;
};

export default CaseCreationErrorAlert;
